export var constantUnit = 8;
export var defaultBorderRadius = 2;
export var defaultSpacing = 16;